import styled from 'styled-components';

export const CrispImg = styled.img`
  display: block;
  padding: 0;
  margin: 0;
  image-rendering: pixelated;
  image-rendering: -moz-crisp-edges;
  image-rendering: crisp-edges;
`;

export default CrispImg;